export enum STORAGE {
  TRACE_ID='traceId',
  USER_PROFILE = 'userProfile',
  CLUSTER_INFO = 'clusterInfo',
  ACCESS_TOKEN = 'access_token',
  FLE_ADMIN_MODULE = 'get_fle_admin_module',
  ORGANISATION_MODULE = 'get_organisation_module',
  RESET_PASSWORD_TOKEN = 'reset_pwd_token',
  ACCESS_CONTROL_DATA = 'access_control_data',
  SELECTED_DASHBOARD_VIEW = 'selected_dashboard_view',
  STORED_URL = 'stored_url',
  USER = 'user',
  USER_ROLE = 'user_role',
  ORG_ID = 'org_id',
  LOGGED_IN_USER_ID = 'logged_in_user_id',
  EMAIL_ACTIVATED = 'email_activated',
  PREFERENCE = 'saved_preference',
  POLICIES = 'policies',
  IS_DEMO_LOGIN = 'demo_login',
  EDGE_BREADCRUMB_NAME = 'edge_device_name',
  EDGE_BREADCRUM_IDENTIFIER = 'edge_device_identifier',
  EDGE_MEASUREMENT_DEVICE_IDENTIFIER = 'edge_measurement_device_identifier',
}
